import messages from './cmsLifecycleConfirm.json' with { type: 'json' };

export const cmsLifecycleConfirmFi: Readonly<typeof messages> = messages;
